export const SnackbarActionTypes = {
    "SHOW_SNACKBAR" : "SHOW_SNACKBAR",
    "HIDE_SNACKBAR" : "HIDE_SNACKBAR"
}